import React from "react";

function JawAbnormalities() {
  return <div>Jaw Abnormalities</div>;
}

export default JawAbnormalities;
